/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagToDeleteRefused } from '../../models/tag-to-delete-refused';

export interface DeleteTags$Params {
  
    /**
     * list of tags uid to be deleted
     */
    body: Array<string>
}

export function deleteTags(http: HttpClient, rootUrl: string, params: DeleteTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagToDeleteRefused>>> {
  const rb = new RequestBuilder(rootUrl, deleteTags.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagToDeleteRefused>>;
    })
  );
}

deleteTags.PATH = '/tags/delete';
